<style lang="scss" scoped>
.tribe-box-image-text {
    .ar {
        position: relative;

        img {
            position: absolute;
            top: 0px;
            bottom: 0px;
            left: 0px;
            right: 0px;
            border-radius: 4px;
            width: 100%;
            height: 100%;
            object-fit: cover;
            font-family: "object-fit: cover;";
        }
    }

    &.image-left {
        .content-wrapper {
            @media screen and (min-width: 1280px) {
                padding: 0 68px 0 132px;
            }
        }
    }

    &.image-right {
        .content-wrapper {
            @media screen and (min-width: 1280px) {
                padding: 0 68px;
            }
        }
    }
}
</style>

<template>
    <div class="tribe-box-image-text" :class="direction">
        <div class="row">
            <div class="col-12 col-xl-6 mb-24 mb-xl-0" :class="{'order-xl-1': direction === 'image-right'}">
                <!--<div class="ar" :style="{ 'padding-top' : `${ (arHeight / arWidth) * 100 }%` }">-->
                    <img class="w-100 h-auto" :src="tribeBox.acf.image.sizes.medium_large" :alt="tribeBox.title.rendered">
                <!--</div>-->
            </div>
            <div class="col-12 col-xl-6" :class="{'order-xl-0': direction === 'image-right'}">
                <div class="content-wrapper">
                    <h2 class="mb-16" v-html="tribeBox.title.rendered"></h2>
                    <div class="text-dark font-weight-light small mb-24 mb-child-0">
                        <show-more :content="tribeBox.acf.description"></show-more>
                    </div>
                    <a class="btn btn-accent" href="#" @click.prevent="toggleSlideout">Bestel deze Tribe Box <span class="arrow-right" v-html="svg('arrow-right')" /></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { bus } from '@/app';

export default {
    props: {
        tribeBox: {
            type: Object,
            required: true
        },

        ratio: {
            type: [String, Boolean],
            default: '588:255',
            required: false
        },

        direction: {
            type: String,
            default: 'image-left',
            required: false
        },
    },

    data: (vm) => ({
        orders: {
            tribeBoxes: [vm.tribeBox]
        }
    }),


    computed: {
        arWidth() {
            if (!this.ratio) return 0
            return this.ratio.split(':')[0]
        },

        arHeight() {
            if (!this.ratio) return 0
            return this.ratio.split(':')[1]
        },
    },

    methods: {
        toggleSlideout() {
            this.$root.slideoutIsOpen = !this.$root.slideoutIsOpen;
            bus.$emit('orderSlideout', { orders: this.orders, formType: 'tribeBoxes' });
        },
    }
}
</script>